import { Route } from "@angular/router";
import { SolicitarEmprestimoPage } from "./solicitar-emprestimo.page";

export const SolicitarEmprestimoRouter: Route[] = [
  { path: 'solicitar-emprestimo', component: SolicitarEmprestimoPage }
];
